export default __webpack_public_path__ + "static/media/S4BannerDigitalExecution.6ae90b77.png";